import { combineReducers } from "redux"
import userReducer from "./slice/userInfoSlice"
import masterInfoReducer from "./slice/masterInfoSlice"
import languageReducer from "./slice/languageSlice"
import rolesReducer from "./slice/rolesSlice"
import templateReducer from "./slice/templateSlice"
import timeEntriesSlice from "./slice/timeEntriesSlice"
import emailCountSlice from "./slice/emailCountSlice"
import invoiceReducer from "./slice/invoiceSlice"

const rootReducer = combineReducers({
  languageState: languageReducer,
  masterState: masterInfoReducer,
  userState: userReducer,
  roles: rolesReducer,
  template: templateReducer,
  times: timeEntriesSlice,
  emailCount: emailCountSlice,
  invoice: invoiceReducer,
})

export default rootReducer
